import { render, staticRenderFns } from "./explain-popup.vue?vue&type=template&id=4b3e73e7"
import script from "./explain-popup.vue?vue&type=script&lang=js"
export * from "./explain-popup.vue?vue&type=script&lang=js"
import style0 from "./explain-popup.vue?vue&type=style&index=0&id=4b3e73e7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports